// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';

export const organizationGroupSchema = z.object({
  id: idSchema,
  name: z.string(),
  isTrial: z.boolean(),
  isProduction: z.boolean(),
  deploymentLocation: z.string(),
  features: z.record(
    z.object({
      enabled: z.boolean().optional(),
    })
  ),
  usage: z.record(z.unknown()),
});
